export type CsatDisplayType = 'star' | 'emoji' | 'number';

export interface SupportMessageCsatView {
  isCsat: boolean;
  askComment: boolean;
  displayType: CsatDisplayType;
  submittedRating?: number | null;
  submittedFeedback?: string | null;
  openedAt?: string | null;
}

function normalizeDisplayType(value: unknown): CsatDisplayType {
  const raw = String(value ?? '').toLowerCase();
  if (raw === 'star' || raw === 'number' || raw === 'emoji')
  {
    return raw;
  }

  return 'emoji';
}

export function parseSupportMessageCsat(contentAttributes?: string | null): SupportMessageCsatView {
  if (!contentAttributes)
  {
    return {
      isCsat: false,
      askComment: true,
      displayType: 'emoji',
    };
  }

  try
  {
    const parsed = JSON.parse(contentAttributes) as Record<string, unknown>;
    const contentType = String(parsed.contentType ?? '').toLowerCase();
    if (contentType !== 'input_csat')
    {
      return {
        isCsat: false,
        askComment: true,
        displayType: 'emoji',
      };
    }

    const ratingRaw = parsed.submittedRating;
    const rating = typeof ratingRaw === 'number'
      ? ratingRaw
      : (typeof ratingRaw === 'string' ? Number(ratingRaw) : null);

    const openedAt = typeof parsed.openedAt === 'string' && parsed.openedAt.trim()
      ? parsed.openedAt
      : null;

    return {
      isCsat: true,
      askComment: parsed.askComment !== false,
      displayType: normalizeDisplayType(parsed.displayType),
      submittedRating: Number.isFinite(rating) ? rating : null,
      submittedFeedback: typeof parsed.submittedFeedback === 'string'
        ? parsed.submittedFeedback
        : null,
      openedAt,
    };
  }
  catch
  {
    return {
      isCsat: false,
      askComment: true,
      displayType: 'emoji',
    };
  }
}

export function formatCsatRatingLabel(displayType: CsatDisplayType, rating: number): string {
  if (displayType === 'emoji')
  {
    const emojis: Record<number, string> = {
      1: '😠',
      2: '😕',
      3: '😐',
      4: '🙂',
      5: '😄',
    };
    return emojis[rating] ?? String(rating);
  }

  if (displayType === 'star')
  {
    return `${'★'.repeat(rating)}${'☆'.repeat(Math.max(0, 5 - rating))}`;
  }

  return String(rating);
}
